require('../../../../Crud/resources/js/form/inputs/switch.js');

// Ajax post for normal cookies
common.View.create('website::partials.Cookies', {

    onDOMLoad()
    {
        this.initModal();
        this.initSendForm();
    },

    initModal()
    {
        $('[data-target="#cookiesModal"]')
            .on('click', (event) => {
                $('body').addClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeIn('fast');

                return false;
            });
    },

    initSendForm()
    {
        this.element.find('form')

            .on('submit', (event) =>
            {
                // Ajax call
                $.post('/save-cookies', {allCookies: 1})
                    .done(() => {
                        this.element.find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});

// TODO Critical: Move to own .js?
// Ajax post for modal cookies
common.View.create('website::partials.Modal', {

    onDOMLoad()
    {
        this.initClose();
        this.initSendForm();
    },

    initClose()
    {
        // Click outside of div?
        $('#cookiesModal')
            .on('click', (event) => {
                let container = this.element;

                // Check for click outside div
                if (!container.is(event.target) && container.has(event.target).length === 0) {
                    $('body').removeClass('overflow-hidden')
                        .find('.modals #cookiesModal').fadeOut('fast');
                }
            });

        // Dismiss by close button
        this.element
            .find('[data-dismiss]')
            .on('click', (event) => {
                $('body').removeClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeOut('fast');
            })
            .end();
    },

    initSendForm()
    {
        this.element.find('form button[type=submit]')

            .on('click', (event) =>
            {
                // Get form data
                let data = this.element.find('form').serializeArray();
                data.push({ name: event.currentTarget.name, value: event.currentTarget.value });

                // Ajax call
                $.post('/save-cookies', data)
                    .done(() => {
                        // Hide modal
                        $('body').removeClass('overflow-hidden')
                            .find('.modals #cookiesModal').fadeOut('fast');

                        // Hide 'footer' cookies
                        $('.website\\:\\:partials-Cookies').find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});
